import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../Assets/logo.png';
import './PageHeader.css';

const PageHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <header className={`page-header ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="logo-section">
        <img src={logo} alt="ApplyAI" className="logo-img" />
        <span className="logo-text">ApplyAI</span>
      </Link>

      <div className="burger" onClick={toggleMenu}>
        <div className="line" />
        <div className="line" />
      </div>
      
      <div className="menu-item">
        <nav className="nav-center">
          <Link to="/" onClick={() => setMenuOpen(false)}><span>Home</span></Link>
          <Link to="/features" onClick={() => setMenuOpen(false)}><span>Features</span></Link>
          <Link to="/pricing" onClick={() => setMenuOpen(false)}><span>Pricing</span></Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}><span>Contact</span></Link>
        </nav>

        <div className="auth-buttons">
          {user ? (
            <>
              <Link to="/dashboard" className="signup-btn" onClick={() => setMenuOpen(false)}>
                <div>Dashboard</div>
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" className="signup-btn" onClick={() => setMenuOpen(false)}>
                <div>Get Started</div>
              </Link>
            </>
          )}
        </div>
      </div>
      <div className={`dropdown-menu ${menuOpen ? 'open' : 'close'}`}>
          <nav>
            <Link to="/" onClick={toggleMenu}><span>Home</span></Link>
            <Link to="/features" onClick={toggleMenu}><span>Features</span></Link>
            <Link to="/pricing" onClick={toggleMenu}><span>Pricing</span></Link>
            <Link to="/contact" onClick={toggleMenu}><span>Contact</span></Link>
            <div className='dropdown-auth-btn'>
              {user ? (
                <>
                  <Link to="/dashboard" className="dropdown-login-btn" onClick={() => setMenuOpen(false)}>
                    <span>{user.name}</span>
                  </Link>
                  <button className="dropdown-signup-btn" onClick={() => { logout(); setMenuOpen(false); }}>
                    <span>Log Out</span>
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="dropdown-login-btn" onClick={() => setMenuOpen(false)}>
                    <span>Log In</span>
                  </Link>
                  <Link to="/signup" className="dropdown-signup-btn" onClick={() => setMenuOpen(false)}>
                    <span>Sign Up</span>
                  </Link>
                </>
              )}
            </div>
          </nav>
        </div>
    </header>
  );
};

export default PageHeader;
